<template>
<div style="display:flex;margin-bottom:5px" class="hoverable clickable pa-2 rounded" @click="openDocument">
    <!-- <template v-slot:activator="{ on }"> -->
    <div>
        <!-- <img v-on="on" :src="documentStyling.path" width="50" height="50" alt="Document" title="Document" style="display:block;margin:2px 20px 0px 6px;vertical-align:middle"/> -->
        <img :src="documentStyling.path" width="50" height="50" alt="Document" title="Document" style="display:block;margin:2px 20px 0px 6px;vertical-align:middle"/>
    </div>
    <!-- </template> -->
    <div>
        {{document.name}}<br/>
        <span v-if="documentStyling.status" :style="{color: documentStyling.textColour}" class="subtle">{{documentStyling.status}} </span>
        <span v-if="document.date" :style="{color: freshness.textColour}">{{freshness.text}}</span>

        <div v-if="document.messageToClient" style="background-color: rgba(255, 230, 0, 0.6);padding-left:5px;padding-right:5px;border-radius:7px">{{document.messageToClient}}</div>

        <template v-if="!document.received">

            <ul style="color:grey" >
                <li v-for="(check, index) in document.checks" :style="checkStyle(check)"  :key="index">{{check.check}}</li>
            </ul>
    
            <a v-for="(link, index2) in document.links" @click.stop style="text-decoration:none;" :key="index2" :href="link.url" target="_blank">
                <div class="hoverable clickable rounded-corners" style="display:flex">
                    <img src="https://taco.insightprocessing.com.au/static/images/cloud-download.png" width="30" height="30" title="Download" alt="Download" style="display:block; opacity:0.4;margin:2px 6px 0px 6px;vertical-align:middle"/>
                    <div style="color:#666;padding:7px 4px">{{link.display}}</div>
                </div>
            </a>
        </template>
    </div>
</div>
</template>

<script>
import Flag from '../../ui-elements/Flag'
import StringHelpers from '../../helpers/StringHelpers'
import DateHelpers from '../../helpers/DateHelpers'
import {differenceInDays} from 'date-fns'

export default {
    data() {
        return {
           
        }
    },

    components: {
        Flag
    },
    
    props: {
        document: Object,
        pageSettings: Object,
    },

    computed: {
        documentStyling() {
            let result = {path: StringHelpers.imagePath(), status: '', textColour: '#888'}

            if(this.document.received) {
                result.path += 'document-success.png'
                result.status = '(received thank you)'
                result.textColour = 'rgba(3, 123, 48, 0.8)'
                result.path = "https://drive.google.com/uc?id=1CFIhEmyal3qYKJsuoi0mKb2tFsqYv0sl"
            }
            else if(this.document.attachment) {
                result.path += 'document-timer.png'
                result.status = '(pending checks)'
                result.textColour = 'rgba(0, 133, 255, 0.9)'
                result.path = "https://drive.google.com/uc?id=1fSMiMY82uR9xlryMLHAS87TzOf1aF1nD"
            }
            else if(this.pageSettings.flagOutstandings) {
                result.path += 'document-error.png'
                result.status = '(outstanding)'
                result.textColour = 'rgba(255, 63, 0, 0.9)'
                result.path="https://drive.google.com/uc?id=1T7KKzNjF7JvHT9T1xgDQsptsucQeQElK"
            }
            else
                result.path += 'document.png'

            return result
        },

        freshness() {
            
            if(!this.document.date) {
                return {}
            }
            let days = differenceInDays(new Date(), DateHelpers.backwardsToDate(this.document.date))
            
            let freshness = {
                textColour: '#bbb',
                text: days + ' days ago',
            }

            if(days < 0)
                freshness.text = 'Invalid Date'
            if(days < 1) {
                freshness.text = 'Today'
            } else if(days < 2) {
                freshness.text = 'Yesterday'
            } else if(days < 14) {
                //nothing needed
            } else if(days < 21) {
                freshness.textColour = 'orange'
            } else if(days > 21) {
                freshness.textColour = 'red'
            }
            return freshness
        }

       
    },

    methods: {

        openDocument() {
            this.$emit('open', this.document)
        },
        checkStyle(check) {
            return {
                'text-decoration': check.complete ? 'line-through' : 'none',
                'color': '#999',
            }
        }        

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// ChecklistDocument.vue?ad6f1b8c